import React, { FunctionComponent, useRef, useState } from "react";
import {
  Typography,
  Grid,
  Paper,
  Divider,
  Button,
} from "@material-ui/core";
import { useStore } from "../../store";
import { useBillStyles } from "./useBillStyles";
import ReactToPrint from "react-to-print";
import PrintIcon from "@material-ui/icons/Print";
import { BillInvoiceDetails } from "./BillInvoiceDetails";
import { BillPaymentDesk } from "./BillPaymentDesk";
import { BillCounterDetails } from "./BillCounterDetails";
import logo from "../../assets/images/billLogo.jpg"; 
import { BillItemDetails } from "./BillItemDetails";
import QRCode from "react-qr-code";
import { width } from "@mui/system";

//import "./Print.css";

type WithBillDetailsProps = {
  billDetails: any
  invalidBillNumber: boolean;
  creditCustomerDetails: Array<object>;
  creditCustomerAvailable: boolean;
  creditCardDetails: Array<object>;
  creditCardAvailable: boolean;

  arabicDetails: any;
};
let Barcode = require("react-barcode");
export const BillDetails: FunctionComponent<WithBillDetailsProps> = ({
  billDetails,
  invalidBillNumber,
  creditCardDetails,
  creditCardAvailable,
  creditCustomerDetails,
  creditCustomerAvailable,
  arabicDetails
}) => {
  const [user] = useStore("auth", "user");
  const [arabicDescription, setArabicDescription] = useState<any>(arabicDetails)
  const componentRef = useRef<any>();
  const classes = useBillStyles();
  return (
    <div >
      <Grid
        container
        direction="row"
        justify="flex-end"
        alignItems="center"
        spacing={3}
        style={{ paddingBottom: "2em"}}
      >
        <Grid item>
          <Typography
            className={classes.printDescription}
          >
            Do you want to print details of bill number:
            {
              billDetails && billDetails.find((a: any) => a.billdocnumber) !== undefined ?
                billDetails && billDetails.find((a: any) => a).billdocnumber
                : ""
            } ?{" "}
          </Typography>
        </Grid>
        <Grid item>
          <ReactToPrint
            trigger={() => (
              <Button variant="contained" color="primary" size="large">
                <PrintIcon />
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle="@page { size: A5 }" // 5.8 in 8.3in,margin:1cm
          />
        </Grid>
      </Grid>
      <Paper elevation={4}>
        {invalidBillNumber ? (
          <Typography className={classes.itemDetailsTypography}>
            No Data
          </Typography>
        ) : (
            <Grid container direction="row" ref={componentRef} style={{maxWidth:"1100px"}}>
              <Grid item xs>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  className={classes.topSpacing}
                >
                  <Grid item xs={6}>
                    <img src={logo}
                      alt="Logo"
                      className={classes.logoImage}
                    />
                  </Grid>
                  <Grid item xs={6}
                  //justify="flex-end"
                    className={classes.QRCodeStyle}
                >
                    <QRCode value={
                        JSON.stringify(billDetails && billDetails.find((a: any) => a.billdocnumber) !== undefined ?
                        billDetails && billDetails.find((a: any) => a).billdocnumber
                        :
                         "")
                    }
                        size={55}
                    />
                </Grid>
                </Grid>
                <Grid
                  container
                  direction="row"
                  // spacing={2}
                  justify="flex-start"
                >
                  <Grid item 
                  style={{paddingLeft:"1em"}}>
                    <Typography
                      className={classes.headingDescription}
                    >
                      {arabicDetails.find((i: any) => i.code === "ADDRESS") !== undefined ?
                        arabicDetails.find((i: any) => i.code === "ADDRESS").value : ""
                      }{" "},
                      </Typography>
                  </Grid>
                  <Grid item >
                    <Typography
                      className={classes.headingDescription}
                    >
                      Email :{arabicDetails.find((i: any) => i.line_number === "2" && i.code === "WEBSITE") !== undefined ?
                        arabicDetails.find((i: any) => i.line_number === "2" && i.code === "WEBSITE").value : ""}{" "}|
                      </Typography>
                  </Grid>
                  <Grid item >
                    <Typography
                      className={classes.headingDescription}
                    >
                      Website:{arabicDetails.find((i: any) => i.line_number === "1" && i.code === "WEBSITE") !== undefined ?
                        arabicDetails.find((i: any) => i.line_number === "1" && i.code === "WEBSITE").value : ""}{" "}|
                      </Typography>
                  </Grid>
                  <Grid item >
                    <Typography
                      className={classes.headingDescription}
                    >
                      CR No:{arabicDetails.find((i: any) => i.line_number === "1" && i.code === "CR_NO") !== undefined ?
                        arabicDetails.find((i: any) => i.line_number === "1" && i.code === "CR_NO").value : ""}{" "}|
                    </Typography>
                  </Grid>
                </Grid>
                <Divider />

                <BillInvoiceDetails
                  billDetails={billDetails}
                  creditCustomerAvailable={creditCustomerAvailable}
                  creditCustomerDetails={creditCustomerDetails}
                  arabicDetails={arabicDetails}
                />

                <Grid container direction="row">
                  <Grid item xs={12} className={classes.topSpacing}>
                    <BillItemDetails 
                    billDetails={billDetails}
                    arabicDetails={arabicDetails}
                    />
                    
                    
                    <Divider />
                    <Grid
                      container
                      direction="row"
                      className={classes.topSpacing}
                      spacing={1}
                      //style={{marginLeft:"10px"}}
                    >
                      <Grid item xs={4}></Grid>
                      <Grid item xs={4}>
                        <Typography
                          className={classes.subTotalKeyStyle}>
                          Sub Total
                          </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography
                          className={classes.subTotalKeyStyle}>
                          {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_SUB_TOTAL") !== undefined ?
                            arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_SUB_TOTAL").arabic_name : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <Typography className={classes.subTotalValueStyle}>
                          {
                            billDetails && billDetails.find((a: any) => a.total) !== undefined ?
                              billDetails && billDetails.find((a: any) => a).total
                              : ""
                          }
                        </Typography>

                      </Grid>
                    </Grid>
                    {
                      <Grid 
                      container 
                      direction="row"
                      spacing={1}
                      //style={{marginLeft:"10px"}}
                      >
                        <Grid item xs={4}></Grid>
                        <Grid item xs={4}>
                          <Typography
                            className={classes.subTotalKeyStyle}
                            style={{paddingRight:5}}
                          >
                          Vat Inc
                              </Typography>
                        </Grid>
                        <Grid item xs={2} >
                          <Typography
                            className={classes.subTotalKeyStyle}>
                            {
                              arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_VAT_INC") !== undefined ?
                                arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_VAT_INC").arabic_name : ""
                            }
                          </Typography>
                        </Grid>
                        <Grid item xs={1} >
                          <Typography className={classes.subTotalValueStyle}>
                            {
                              "0.00"
                            }
                          </Typography>

                        </Grid>
                      </Grid>
                      //   :
                      //   <Grid item xs={6}>{" "}</Grid>
                      // : ""
                    }

                    <Grid 
                    container 
                    direction="row"
                    spacing={1}
                    //style={{marginLeft:"10px"}}
                   >

                      <Grid item xs={4}></Grid>
                      <Grid item xs={4} >
                        <Typography className={classes.netTotalKeyStyle}>
                          Total
                          </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography className={classes.netTotalKeyStyle}>
                          {arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_TOTAL") !== undefined ?
                            arabicDetails.find((i: any) => i.code === "BILL_DISPLAY_TOTAL").arabic_name : ""}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}  >
                        <Typography className={classes.netTotalValueStyle}>
                          {
                            billDetails && billDetails.find((a: any) => a.total) !== undefined ?
                              billDetails && billDetails.find((a: any) => a).total
                              : ""
                          }
                        </Typography>
                      </Grid>
                    </Grid>
                    <Divider />
                    <Grid container direction="row"
                      className={classes.billPaymentDeskStyle}
                    >
                      <Grid item xs >
                        <BillPaymentDesk
                          billDetails={billDetails}
                          creditCardDetails={creditCardDetails}
                          creditCardAvailable={creditCardAvailable}                          
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Divider />
                <BillCounterDetails 
                billDetails={billDetails}
                creditCustomerAvailable={creditCustomerAvailable}
                arabicDetails={arabicDetails}
                />
                {/* <Grid container direction="row">
                <Grid item xs={12} className={classes.barcodeStyle}>
                  <Barcode value={billNumber} format="CODE128" />
                </Grid>
              </Grid> */}
              </Grid>
            </Grid>
          )}
      </Paper>
    </div>
  );
};
